module.exports = __webpack_public_path__ + "static/img/video_des.0e83305.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/video_des.png
// module id = QH7i
// module chunks = 1